module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/alert-circle-white.3a97fd75.svg";